
import { mapActions } from "vuex"
import CreditBoardTable from "@/common/pages/Credits/CreditBoardTable";

export default {
  components: {CreditBoardTable},
  data: () => ({
    credit: null,
    loading: true,
    activeTab: 'summary'
  }),

  computed: {
    creditNumber () {
      return this.$route.params.id
    },

    isSummaryTab () {
      return this.activeTab === 'summary'
    },

    isBoardTab () {
      return this.activeTab === 'board'
    }
  },

  mounted () {
    this.getCreditDetail(this.creditNumber).then(response => {
      this.credit = { ...response.data }
      console.log(this.credit)
      this.loading = false
    }, () => {
      this.$router.push('/credits')
    })
  },

  methods: {
    ...mapActions([
      'getCreditDetail'
    ]),

    toggleTab (tab) {
      if (tab !== this.activeTab) {
        this.activeTab = tab
      }
    }
  }
}
